import { Section, SubmitButton, useFormEvents, FormHub } from '@lib/common';
import { Grid, Box } from '@material-ui/core';
import React, { useCallback } from 'react';
import {
  CorporateAccount,
  CostCenterOption,
  FormStatus,
  getCostCenterOptionsService,
} from '@lib/state';
import {
  CorporateAccountForms,
  corporateAccountService,
  UpdateCorporateAccountBillingRequest,
} from 'app/state';
import { CostCenterSettings } from './cost-center-settings';
import { BillingPolicyForm } from './billing-policy-form';

interface Props {
  account: CorporateAccount;
  defaultCostCenterOptions?: Array<CostCenterOption>;
}

export function CorporateAccountBillingPolicy({ account, defaultCostCenterOptions }: Props) {
  const [{ status }] = useFormEvents(CorporateAccountForms.UpdateBillingSettings);

  const onSubmit = useCallback(
    ({ costCenterOptions, ...formValues }: UpdateCorporateAccountBillingRequest) => {
      if (account.id) {
        corporateAccountService.updateCorporateAccountBillingSettings(account.id, formValues);
      }

      getCostCenterOptionsService().updateCostCenterOptions(account.id, costCenterOptions ?? []);
    },
    [account]
  );

  return (
    <>
      {!!account?.id && (
        <FormHub onSubmit={onSubmit}>
          <Section title="Billing Policy" textAlign="left">
            <BillingPolicyForm account={account} />
          </Section>
          <Section title="Cost Center Options" textAlign="left">
            <Grid container spacing={1}>
              {account?.fields.map((x, i) => (
                <CostCenterSettings
                  index={i}
                  key={x.key}
                  costCenterConfig={x}
                  accountId={account.id}
                  costCenterOptions={defaultCostCenterOptions}
                />
              ))}
            </Grid>
          </Section>
          <Box display="flex" justifyContent="flex-end" pb={2}>
            <SubmitButton
              name="createCorporateAccount"
              variant="contained"
              color="secondary"
              pending={status === FormStatus.Pending}
              disabled={status === FormStatus.Pending}
              data-testid="corporateAccountBillingSubmit"
            >
              {account ? 'Save' : 'Create'} Corporate Account
            </SubmitButton>
          </Box>
        </FormHub>
      )}
    </>
  );
}
